"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_BLOCK_DEFAULTS = exports.FIELD_BLOCK_HEIGHT = void 0;
exports.FieldBlock = FieldBlock;
const jsx_runtime_1 = require("react/jsx-runtime");
const bind_1 = __importDefault(require("classnames/bind"));
const field_block_m_scss_1 = __importDefault(require("./field-block.m.scss"));
const cx = bind_1.default.bind(field_block_m_scss_1.default);
exports.FIELD_BLOCK_HEIGHT = {
    s: 32,
    m: 40,
    l: 56,
};
exports.FIELD_BLOCK_DEFAULTS = {
    size: 'l',
};
/**
 * Блок поля по дизайн-гайдам.
 * @param props Свойства.
 * @return Элемент.
 */
function FieldBlock({ size = exports.FIELD_BLOCK_DEFAULTS.size, main, mainProps, disabled, failed, focused, label, labelProps, labelAsPlaceholder, fixedHeight = true, caption, rootRef, rootProps, blockRef, blockProps, adornmentStart, adornmentEnd, 'data-testid': testId = 'field-block', }) {
    const needLabel = Boolean(label) && (size === 'l' || labelAsPlaceholder);
    const rootClassName = cx('root', `size-${size}`, {
        disabled,
        focused,
        failed,
        'label-as-placeholder': needLabel && labelAsPlaceholder,
        'no-label': !needLabel,
    }, rootProps?.className);
    const blockClassName = cx('block', fixedHeight && 'fixed-height', blockProps?.className);
    return ((0, jsx_runtime_1.jsxs)("div", { ...rootProps, ref: rootRef, className: rootClassName, "data-testid": testId, children: [(0, jsx_runtime_1.jsxs)("div", { ...blockProps, ref: blockRef, className: blockClassName, "data-testid": 'field-block:block', children: [adornmentStart && ((0, jsx_runtime_1.jsx)("div", { className: cx('col', 'adornment-col', 'start'), "data-testid": 'field-block:adornment-start', children: adornmentStart })), (0, jsx_runtime_1.jsxs)("div", { className: cx('col', 'main-col'), children: [needLabel && ((0, jsx_runtime_1.jsx)("label", { ...labelProps, className: cx('label', labelProps?.className), "data-testid": 'field-block:label', children: label })), (0, jsx_runtime_1.jsx)("div", { ...mainProps, className: cx('main', mainProps?.className), "data-testid": 'field-block:main', children: main })] }), adornmentEnd && ((0, jsx_runtime_1.jsx)("div", { className: cx('col', 'adornment-col', 'end'), "data-testid": 'field-block:adornment-end', children: adornmentEnd }))] }), caption && ((0, jsx_runtime_1.jsx)("div", { className: cx('caption'), "data-testid": 'field-block:caption', children: caption }))] }));
}
//# sourceMappingURL=field-block.js.map